import common from './Locales/en/common.json';
import engineering from './Locales/en/engineering.json';
import legal from './Locales/en/legal.json';

export const localeNamespaces = {
  en: {
    common,
    engineering,
    legal,
  },
};

export const DEFAULT_LOCALE = 'en';
